import PropTypes from 'prop-types';
import React, { memo } from 'react';
import classNames from 'classnames';
import { Map } from 'immutable';
import DatePicker from 'react-datepicker';
import moment from 'moment';

import { BrowseCheckbox } from './BrowseCheckbox';
import { BrowseControlContent } from './BrowseControlContent';
import { BrowseAutoComplete } from './BrowseAutoComplete';
import { PresetDateRangeButtons } from './PresetDateRangeButtons';

import style from '../helpers/MultiselectItem/style.module.css';

const BrowseActionFilterComponent = ({ filter, info, onChange, onGetSuggestion }) => {
  const handleSelectPreset = (from, to) => {
    handleStartDateChange(moment(from.toDate()));
    handleEndDateChange(moment(to.toDate()));
  };

  const handleCheckboxChange = ({ filterName, filterData }) => {
    const shouldSetDefaultDates = filterData.checked && !info.get('startDate') && !info.get('endDate');

    onChange({
      filterName,
      filterData: shouldSetDefaultDates ? { ...filterData, startDate: moment(), endDate: moment() } : filterData,
    });
  };

  const handleStartDateChange = date => {
    onChange({
      filterName: filter.get('name'),
      filterData: {
        startDate: date && date.isValid() ? date : null,
      },
    });
  };

  const handleEndDateChange = date => {
    onChange({
      filterName: filter.get('name'),
      filterData: {
        endDate: date && date.isValid() ? date : null,
      },
    });
  };

  const handleEventDescriptionChange = event => {
    const { value } = event.target;

    onChange({
      filterName: filter.get('name'),
      filterData: {
        eventDescription: value,
      },
    });
  };

  const handleAddTag = () => {
    const name = filter.get('name');
    const eventActivity = filter.get('eventActivity');
    let eventSelected = info.get('selected');

    if (!eventSelected) {
      eventSelected = '(any activity)';
    } else {
      eventSelected = eventSelected.get(eventActivity.get('renderField'), '(any activity)');
    }

    const eventDescription = info.get('eventDescription');

    let selectedList = info.get('selectedList');
    const selected = eventDescription === '' ? eventSelected : `${eventSelected} - ${eventDescription}`;

    if (!selectedList.includes(selected)) {
      selectedList = selectedList.push(selected);

      onChange({
        filterName: name,
        filterData: {
          selectedList,
          text: '',
          selected: null,
          eventDescription: '',
        },
      });
    }
  };

  const handleRemoveTag = event => {
    const { name } = event.target;
    const tagIndex = parseInt(name.replace('buyerFilterTag', ''), 10);
    let selectedList = info.get('selectedList');

    selectedList = selectedList.delete(tagIndex);

    onChange({
      filterName: filter.get('name'),
      filterData: {
        selectedList,
      },
    });
  };

  const selectedList = info.get('selectedList');
  const tagListContent = selectedList.map((tag, i) => (
    <div key={tag} className={style.host}>
      {tag}
      <button
        aria-hidden="true"
        aria-label="close"
        className={classNames(style.close, 'close btn-xs')}
        name={`buyerFilterTag${i}`}
        onClick={handleRemoveTag}
        type="button"
      >
        &times;
      </button>
    </div>
  ));

  return (
    <BrowseCheckbox filter={filter} info={info} onChange={handleCheckboxChange}>
      <BrowseControlContent variant="activity">
        <div className="form-inline">
          <PresetDateRangeButtons onSelectPreset={handleSelectPreset} />
          <div className="form-group mt5">
            <DatePicker
              className="form-control"
              dateFormat="MM/DD/YYYY"
              dropdownMode="select"
              onChange={handleStartDateChange}
              placeholderText="Start Date"
              selected={info.get('startDate')}
              showMonthDropdown
              showYearDropdown
            />
          </div>
          <div className="form-group">
            <DatePicker
              className="form-control"
              dateFormat="MM/DD/YYYY"
              dropdownMode="select"
              onChange={handleEndDateChange}
              placeholderText="End Date"
              selected={info.get('endDate')}
              showMonthDropdown
              showYearDropdown
            />
          </div>
          {tagListContent}
          <div className="mt5">
            <BrowseAutoComplete
              className="form-control"
              filter={filter.get('eventActivity')}
              info={info}
              onChange={onChange}
              onGetSuggestion={onGetSuggestion}
            />
          </div>
          <div className="form-group input-group">
            <input
              className="form-control"
              onChange={handleEventDescriptionChange}
              placeholder="Event Description"
              type="text"
              value={info.get('eventDescription')}
            />
            <span className="input-group-addon" onClick={handleAddTag}>
              <i aria-hidden="true" className="fa fa-plus" />
            </span>
          </div>
        </div>
      </BrowseControlContent>
    </BrowseCheckbox>
  );
};

BrowseActionFilterComponent.propTypes = {
  filter: PropTypes.instanceOf(Map).isRequired,
  info: PropTypes.instanceOf(Map).isRequired,
  onChange: PropTypes.func.isRequired,
  onGetSuggestion: PropTypes.func.isRequired,
};

/** Browse action filter component. */
export const BrowseActionFilter = memo(BrowseActionFilterComponent);
